














import { activityLogName } from "@/lib/utility/activityLogName";
import { simpleDate } from "@/lib/utility/date-helper";
import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import { Component, Prop } from "vue-property-decorator";
import TimelineCard from "../utility/TimelineItem.vue";
import ActivityTimeLineItemDelete from "./ActivityTimeLineItemDelete.vue";
import { IActivityLog } from "@/models/activity-log.entity";

@Component({
  components: {
    TimelineCard,
    ActivityTimeLineItemDelete
  }
})
export default class ActivityTimeLineItemReportSummaryCreated extends DarkModeHighlightMixin {
  @Prop({})
  activityLogEntry!: IActivityLog;

  get content() {
    return this.activityLogEntry.comment;
  }

  get name() {
    return activityLogName(this.activityLogEntry);
  }

  get date() {
    return simpleDate(this.activityLogEntry.timestamp.created);
  }
}
